<h2 mat-dialog-title>{{ 'driver.settings.edi_still_in_use' | translate }}</h2>
<mat-dialog-content>
  <div class="ekv-content-container">
    <div class="ekv-content-icon">
      <mat-icon class="warning-icon__large" [svgIcon]="'info'"></mat-icon>
    </div>
    <div [innerHTML]="'driver.settings.edi_still_in_use_info' | translate: { key: data.key }"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="ekv-action-container">
  <crm-button-secondary mat-dialog-close>{{ 'general.abbort' | translate }}</crm-button-secondary>
  <crm-button-delete (clicked)="forceDelete()">{{
    'general.delete_force' | translate
  }}</crm-button-delete>
</mat-dialog-actions>
